import React from "react";

const MapAreas = () => {
  const plotCoordinates = [
  { id: "plot-h1", coords: "2829,2567, 2799,2818, 3015,2814, 3020,2572", alt: "plot-h1" },
  { id: "plot-h2", coords: "2652,2565, 2601,2818, 2792,2817, 2824,2569", alt: "plot-h2" },
  { id: "plot-h3", coords: "2485,2569, 2439,2815, 2596,2817,2646,2570", alt: "plot-h3" },
  { id: "plot-h4", coords: "2320,2570, 2269,2815, 2436,2817, 2479,2570", alt: "plot-h4" },
  { id: "plot-h5", coords: "2157,2570,2108,2817, 2266,2815, 2313,2569", alt: "plot-h5" },
  { id: "plot-h6", coords: "2001,2569, 1936,2834, 1973,2826, 2103,2820, 2154,2569", alt: "plot-h6" },
  { id: "plot-h7", coords: "1842,2569, 1747,2868, 1793,2869, 1931,2834, 1994,2572", alt: "plot-h7" },
  { id: "plot-h8", coords: "1933,2320,1846,2564, 1997,2565, 2071,2327", alt: "plot-h8" },
  { id: "plot-h9", coords: "2073,2327, 2003,2564, 2156,2567, 2223,2333", alt: "plot-h9" },
  { id: "plot-h10", coords: "2226,2331, 2159,2562, 2318,2565, 2375,2339", alt: "plot-h10" },
  { id: "plot-h11", coords: "2380,2341, 2321,2562, 2480,2564, 2538,2347", alt: "plot-h11" },
  { id: "plot-h12", coords: "2542,2347, 2485,2564, 2649,2565, 2703,2354", alt: "plot-h12" },
  { id: "plot-h13", coords: "2708,2354, 2652,2564, 2826,2564, 2870,2360", alt: "plot-h13" },
  { id: "plot-h14", coords: "2876,2359, 2832,2565, 3020,2564, 3016,2366", alt: "plot-h14" },
  { id: "plot-h15", coords: "2905,2114, 2875,2338, 3020,2343, 3008,2117", alt: "plot-h15" },
  { id: "plot-h16", coords: "2776,2110, 2744,2333, 2869,2338, 2902,2114", alt: "plot-h16" },
  { id: "plot-h17", coords: "2649,2105, 2615,2329, 2742,2335, 2775,2109", alt: "plot-h17" },
  { id: "plot-h18", coords: "2520,2101, 2488,2325, 2611,2327, 2643,2106", alt: "plot-h18" },
  { id: "plot-h19", coords: "2391,2096, 2358,2317, 2484,2324, 2515,2098", alt: "plot-h19" },
  { id: "plot-h20", coords: "2264,2093, 2223,2311, 2355,2316, 2386,2096", alt: "plot-h20" },
  { id: "plot-h21", coords: "2138,2086, 2091,2303, 2219,2311, 2261,2088", alt: "plot-h21" },
  { id: "plot-h22", coords: "2019,2080, 1943,2292, 2086,2303, 2134,2086", alt: "plot-h22" },
  { id: "plot-h23", coords: "2838,1869, 2845,2090, 3007,2096, 2994,1867", alt: "plot-h23" },
  { id: "plot-h24", coords: "2678,1867, 2678,2085, 2840,2090, 2834,1867", alt: "plot-h24" },
  { id: "plot-h25", coords: "2507,1865, 2509,2079, 2671,2083, 2673,1869", alt: "plot-h25" },
  { id: "plot-h26", coords: "2340,1861, 2334,2072, 2503,2079, 2501,1867", alt: "plot-h26" },
  { id: "plot-h27", coords: "2210,1857, 2196,2063, 2329,2072, 2340,1859", alt: "plot-h27" },
  { id: "plot-h28", coords: "2103,1857, 2032,2055, 2194,2063, 2207,1859", alt: "plot-h28" },
  { id: "plot-h29", coords: "2175,1655, 2105,1854, 2302,1855, 2338,1516, 2290,1504, 2237,1668, 2189,1651, 2183,1651, 2180,1652, 2177,1654", alt: "plot-h29" },
  { id: "plot-h30", coords: "2341,1516, 2304,1855, 2420,1860, 2439,1538", alt: "plot-h30" },
  { id: "plot-h31", coords: "2442,1539,2424,1861, 2544,1863, 2552,1567", alt: "plot-h31" },
  { id: "plot-h32", coords: "2555,1567, 2545,1864,2677,1867, 2674,1599", alt: "plot-h32" },
  { id: "plot-h33", coords: "2678,1601, 2679,1865, 2823,1865, 2821,1632", alt: "plot-h33" },
  { id: "plot-h34", coords: "2825,1633, 2825,1864, 2993,1863, 2991,1677", alt: "plot-h34" },
];


  return (
    <map name="projectMap">
      {plotCoordinates.map((plot) => (
        <area
          key={plot.id}
          shape="poly"
          coords={plot.coords}
          href="#"
          alt={plot.alt}
          data-key={plot.id}
        />
      ))}
    </map>
  );
};

export default MapAreas;